export default {
  maxImageSize: 10 * 1000 * 1000, // 10MB in bytes
  maxDocSize: 100 * 1000 * 1000, // Updated to 100MB in bytes
  maxVideoSize: 100 * 1000 * 1000, // 100MB in bytes
}
